import React from 'react'

import { useSettings } from '../../hooks/useSettings'

const EyeClosedSVG = ({ isWhite = false }) => {
  const { isDarkMode } = useSettings()

  const color = isWhite ? '#ffffff' : isDarkMode ? '#ffffff' : '#0E2E4C'

  return (
    <svg
      className="h-[16px] desktop:h-[20px] w-[16px] desktop:w-[20px]"
      width="20px"
      height="20px"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth="0" />
      <g strokeLinecap="round" strokeLinejoin="round" />
      <g>
        <rect width="48" height="48" fill="white" fillOpacity="0.01" />
        <path
          d="M6 16C6.63472 17.2193 7.59646 18.3504 8.82276 19.3554C12.261 22.1733 17.779 24 24 24C30.221 24 35.739 22.1733 39.1772 19.3554C40.4035 18.3504 41.3653 17.2193 42 16"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.9777 24L31.0482 31.7274"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.3535 21.3536L43.0104 27.0104"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.99998 27.0104L10.6568 21.3536"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9276 31.7274L18.9982 24"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default EyeClosedSVG
